var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Checkbox',{class:_vm.classes,attrs:{"value":_vm.value,"label":_vm.label,"disabled":_vm.disabled,"indeterminate":_vm.indeterminate,"size":_vm.size},on:{"input":_vm.onInput,"on-change":_vm.onChange}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }